<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table :headers="headers" :items="items" :search="search_cliente">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('suppliers-table-top-t1') }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field v-model="search_cliente" :label="$t('search')" outlined dense hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevoProveedor()"> {{ $t('suppliers-table-top-btn1') }} </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.activo`]="{ item }">
        <v-chip color="green" dark v-if="item.activo">ACTIVO</v-chip>
        <v-chip color="red" dark v-else>INACTIVO</v-chip>
      </template>

      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon class="mr-2" @click="editarProveedor(item)" :disabled="$store.state.usuario.rol == 'Solo Vista'">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>
    </v-data-table>


    <v-dialog v-model="dialog" width="1000" persistent>
      <v-card>
        <v-card-title>
          <v-checkbox v-model="activo" :label="$t('suppliers-table-dialog-t1')" dense hide-details></v-checkbox>
        </v-card-title>
        <v-row no-gutters class="my-1">
          <v-col cols="12">
            <v-card class="mx-3" elevation="0" style="border: 1px solid black">
              <v-card-text>
                <v-row no-gutters>

                  <v-col cols="12" md="2" class="pa-1">
                    <v-text-field v-model="codigo" :label="$t('suppliers-table-dialog-t2')" @input="upperLetter"
                      outlined dense hide-details :error="errorCodigo"></v-text-field>
                  </v-col>

                  <v-col cols="12" class="pa-1">
                    <v-text-field v-model="nombre" :label="$t('suppliers-table-dialog-t3')" @input="upperLetter"
                      outlined dense hide-details :error="errorNombre"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pa-1">
                    <v-autocomplete v-model="id_departamento" :items="items_departamento" item-text="nombre"
                      item-value="id_departamento" :label="$t('suppliers-table-dialog-t4')" outlined dense hide-details
                      @input="listarMunicipios(id_departamento)" :error="errorDepartamento"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6" class="pa-1">
                    <v-autocomplete v-model="id_municipio" :items="items_municipio" item-text="nombre"
                      item-value="id_municipio" :label="$t('suppliers-table-dialog-t5')" outlined dense hide-details
                      :error="errorMunicipio"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" class="pa-1">
                    <v-text-field v-model="direccion" :label="$t('suppliers-table-dialog-t6')" outlined dense
                      hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" md="9" class="pa-1">
                    <v-autocomplete v-model="id_actividad_economica" :items="items_actividad_economica"
                      item-text="nombre" item-value="id_actividad_economica" :label="$t('suppliers-table-dialog-t7')"
                      outlined dense hide-details :error="errorActividadEconomica"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3" class="pa-1">
                    <v-autocomplete v-model="tamaño" :items="items_tamaño" :label="$t('suppliers-table-dialog-t8')"
                      outlined dense hide-details :error="errorTamaño"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-text-field v-model="correo_1" :label="$t('suppliers-table-dialog-t9')" outlined dense
                      hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-text-field v-model="correo_2" :label="$t('suppliers-table-dialog-t10')" outlined dense
                      hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-text-field v-model="telefono" :label="$t('suppliers-table-dialog-t11')" outlined dense
                      hide-details :error="errorTelefono"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="id_identificador" :items="items_identificador" item-text="nombre"
                      item-value="id_identificador" :label="$t('suppliers-table-dialog-t12')" outlined dense
                      hide-details :error="errorIdentificador"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-text-field v-model="documento_identificador" :label="$t('suppliers-table-dialog-t13')" outlined
                      dense hide-details :error="errorDocumentoIdentificador"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-text-field v-model="registro" :label="$t('suppliers-table-dialog-t14')" outlined dense
                      hide-details :error="errorDocumentoIdentificador"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="my-1">
          <v-col cols="12">
            <v-card class="mx-3" elevation="0" style="border: 1px solid black">
              <!-- Gastos -->
              <v-card-text>

                <v-row no-gutters>
                  <v-col cols="12" md="6" class="pa-1">
                    <v-checkbox :label="$t('suppliers-table-dialog-t15')" v-model="selec_manual"
                      @change="modoManual(selec_manual)" dense hide-details></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="12" class="pa-1">
                  </v-col>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="tipo_operacion" :items="items_tipo_operacion" item-text="tipo_operacion"
                      item-value="codigo" :value-comparator="(a, b) => Number(a) === Number(b)"
                      :label="$t('suppliers-table-dialog-t16')" outlined dense hide-details
                      @change="actualizarCostoGastos">
                      <template v-slot:selection="data">
                        {{ data.item.codigo }} {{ data.item.tipo_operacion }}
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.codigo }} {{ data.item.tipo_operacion }}
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="clasificacion" :items="items_clasificacion" item-text="clasificacion"
                      item-value="codigo" :value-comparator="(a, b) => Number(a) === Number(b)"
                      :label="$t('suppliers-table-dialog-t17')" outlined dense hide-details
                      @change="actualizarCostoGastos">
                      <template v-slot:selection="data">
                        {{ data.item.codigo }} {{ data.item.clasificacion }}
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.codigo }} {{ data.item.clasificacion }}
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="costo_gastos" :items="items_costogasto" item-text="costo_gasto"
                      item-value="id_costo_gasto" :label="$t('suppliers-table-dialog-t18')" outlined dense hide-details>
                      <template v-slot:selection="data">
                        {{ data.item.codigo }} {{ data.item.costo_gasto }}
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.codigo }} {{ data.item.costo_gasto }}
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- CHECKBOX ... -->
        <v-row no-gutters class="my-1">
          <v-col cols="12">
            <v-card class="mx-3" elevation="0" style="border: 1px solid black">
              <v-card-text>
                <v-row no-gutters>

                  <v-col cols="12" md="1"></v-col>

                  <v-col cols="12" md="4">
                    <v-checkbox v-model="con_retencion" :label="$t('suppliers-table-dialog-t19')" dense hide-details
                      @change="estadoRetencion()"></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox v-model="con_percepcion" :label="$t('suppliers-table-dialog-t20')" dense hide-details
                      @change="estadoPercepcion()"></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox v-model="exento" :label="$t('suppliers-table-dialog-t21')" dense
                      hide-details></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- EXTRANJERO, TIPO EXPORT, ZONA -->
        <v-row no-gutters class="my-1">
          <v-col cols="12">
            <v-card class="mx-3" elevation="0" style="border: 1px solid black">
              <!-- EXTRANJERO, TIPO EXPORT, ZONA -->
              <v-card-text class="pb-0">
                <v-row no-gutters>
                  <v-col cols="auto" md="3">
                    <v-checkbox v-model="exterior" :label="$t('suppliers-table-dialog-t22')" dense
                      hide-details></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6" class="pa-1">
                    <v-autocomplete v-model="area" :items="items_area" item-text="text" item-value="value"
                      :label="$t('suppliers-table-dialog-t23')" outlined dense hide-details
                      :error="errorArea"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- EXTRANJERO, TIPO EXPORT, ZONA, PAIS -->
              <v-card-text class="pb-0">
                <v-row justify="center" no-gutters>
                  <v-col cols="auto" class="pa-1" align-self="center">
                    <v-btn outlined @click="listarPaises('nuevo')" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                      <v-icon color="grey">fa-solid fa-magnifying-glass-plus</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="id_pais" :items="items_paises" item-text="nombre" item-value="id_pais"
                      :label="$t('suppliers-table-dialog-t24')" outlined dense hide-details readonly
                      :error="errorPais"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-btn color="primary" @click="crearProveedor()" v-if="flag_nuevo_edit == 1" :disabled="$store.state.usuario.rol == 'Solo Vista'">
            {{ $t('btn-save') }}
          </v-btn>
          <v-btn color="primary" @click="actualizarProveedor()" v-if="flag_nuevo_edit == 2" :disabled="$store.state.usuario.rol == 'Solo Vista'">
            {{ $t('btn-update') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogProveedor()">{{ $t('btn-close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- VENTANA PARA MOSTRAR LOS PAISES -->
    <v-dialog v-model="dialog_paises" width="500">
      <v-data-table :headers="headers_paises" :items="items_paises" :search="search" @dblclick:row="setPais">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Países</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="BUSCAR" outlined dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">fa-solid fa-circle-info</v-icon>
              </template>
              <span>Doble click para seleccionar el país</span>
            </v-tooltip>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="8000" color="blue" multi-line elevation="24" outlined top right>
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import settings from "../../settings/settings";
import moment from "moment";

export default {
  data: () => ({
    snackbar: false,
    snackbar_text: "Mensaje",
    icon_snackbar: "fa-solid fa-circle-info",
    search: "",
    items: [],
    id_empresa: 0,
    //PROVEEDOR
    id_proveedor: 0,
    codigo: "",
    nombre: "",
    id_departamento: null,
    items_departamento: [],
    id_municipio: null,
    items_municipio: [],
    direccion: "",
    tamaño: "",
    items_tamaño: ["PEQUEÑO", "MEDIANO", "GRANDE", "OTROS"],
    correo_1: "",
    correo_2: "",
    telefono: "",
    id_identificador: "",
    items_identificador: [],
    documento_identificador: "",
    registro: "",

    con_retencion: false,
    activo: true,
    exento: false,
    con_percepcion: false,
    exterior: false,
    headers_paises: [
      { text: "Codigo", value: "cod_pais", align: "center" },
      { text: "Nombre", value: "nombre" },
    ],
    id_pais: "",
    items_paises: [],
    area: "",
    items_area: [
      { text: "LOCAL", value: "L" },
      { text: "IMPORTACION", value: "I" },
      { text: "INTERNACION", value: "R" },
    ],
    id_actividad_economica: "",
    items_actividad_economica: [],
    dialog: false,
    dialog_paises: false,
    flag_nuevo_edit: 1,
    errorCodigo: false,
    errorNombre: false,
    errorDepartamento: false,
    errorMunicipio: false,
    errorActividadEconomica: false,
    errorTamaño: false,
    errorTelefono: false,
    errorIdentificador: false,
    errorDocumentoIdentificador: false,
    errorArea: false,
    errorPais: false,

    search_cliente: "",

    //Nuevos
    selec_manual: false,
    tipo_operacion: "",
    clasificacion: "",
    costo_gastos: "",
    items_tipo_operacion: [],
    items_clasificacion: [],
    items_costogasto: [],
  }),
  created() {
    if (this.$store.state.emp.id_empresa) {
      this.inicializarDatos();
    } else {

    };
  },
  watch: {

    "$store.state.emp.id_empresa": function (newVal, oldVal) {
      if (newVal) {
        this.inicializarDatos();
      }
    },
    "$store.state.usuario.id_usuario": function (newVal, oldVal) {
      if (newVal) {
        this.inicializarDatos();
      }
    },

    tipo_operacion(newVal) {
      this.actualizarCostoGastos();
    },
    clasificacion(newVal) {
      this.actualizarCostoGastos();
    },
    selec_manual(newVal) {
      this.modoManual(newVal);
    },



  },
  computed: {

    headers() {
      return [
        { text: this.$t("suppliers-header-t1"), value: "codigo" },
        { text: this.$t("suppliers-header-t2"), value: "nombre" },
        { text: this.$t("suppliers-header-t3"), value: "documento_identificador" },
        { text: this.$t("suppliers-header-t4"), value: "telefono" },
        { text: this.$t("suppliers-header-t5"), value: "correo_1" },
        { text: this.$t("suppliers-header-t6"), value: "activo", align: "center" },
        { text: this.$t("suppliers-header-t7"), value: "action_edit", sortable: false },
      ];
    },





    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarProveedores();
        this.listarDepartamentos();
        this.listarIdentificadores();
        this.listarTipoDocFiscales();
        this.listarTipoExportacion();
        this.listarActividadEconomica();
        return true;
      }
    },
  },
  methods: {
    upperLetter() {
      this.codigo = this.codigo.toUpperCase();
    },

    inicializarDatos() {
      this.listarTipoOperacion();
      this.listarClasificacion();
      this.listarCostoGasto();
    },

    listarTipoOperacion() {
      axios.get("api/TipoOperacion/Listar")
        .then((response) => {
          this.items_tipo_operacion = response.data;
        });
    },
    listarClasificacion() {
      axios.get("api/Clasificacion/Listar")
        .then((response) => {
          this.items_clasificacion = response.data;
        });
    },
    listarCostoGasto() {
      axios.get("api/CostoGasto/Listar")
        .then((response) => {
          this.items_costogasto = response.data;
        });
    },

    calcularTipoCostoGasto() {
      if (this.tipo_operacion && this.clasificacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.tipo_operacion}-${this.clasificacion}`;
        console.log("Key:", key);
        console.log("Tipo de Costo/Gasto encontrado:", combinaciones[key]);

        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    calcularTipoCostoGastoo() {
      if (this.clasificacion && this.tipo_operacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.clasificacion}-${this.tipo_operacion}`;
        console.log("Key:", key);
        console.log("Tipo de Costo/Gasto encontrado:", combinaciones[key]);

        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    actualizarCostoGastos() {
      if (this.tipo_operacion && this.clasificacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.tipo_operacion}-${this.clasificacion}`;
        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    actualizarCostoGastoos() {
      if (this.clasificacion && this.tipo_operacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.clasificacion}-${this.tipo_operacion}`;
        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    modoManual(newVal) {
      if (newVal) {
        this.tipo_operacion = null;
        this.clasificacion = null;
        this.costo_gastos = null;
      }
    },


    listarProveedores() {
      if (this.$store.state.emp.id_empresa != undefined)
        axios
          .get("api/Proveedores/Listar/" + this.$store.state.emp.id_empresa)
          .then((response) => {
            this.items = response.data;
          });
    },

    nuevoProveedor() {
      this.flag_nuevo_edit = 1;
      this.dialog = true;
    },
    crearProveedor() {
      if (this.validarFormulario()) {
        axios
          .post("api/Proveedores/Crear", {
            id_departamento: this.id_departamento,
            id_municipio: this.id_municipio,
            id_identificador: this.id_identificador,
            id_pais: this.id_pais,
            id_empresa: this.$store.state.emp.id_empresa,
            id_actividad_economica: this.id_actividad_economica,
            codigo: this.codigo,
            nombre: this.nombre,
            direccion: this.direccion,
            tamaño: this.tamaño,
            correo_1: this.correo_1,
            correo_2: this.correo_2,
            telefono: this.telefono,
            documento_identificador: this.documento_identificador,
            registro: this.registro,
            con_retencion: this.con_retencion,
            activo: this.activo,
            exento: this.exento,
            con_percecion: this.con_percepcion,
            exterior: this.exterior,
            area: this.area,

            //Nuevos
            selec_manual: this.selec_manual,
            tipo_operacion: this.tipo_operacion,
            clasificacion: this.clasificacion,
            costo_gastos: this.costo_gastos,

          })
          .then(() => {
            this.snackbar_text = this.$t('suppliers-snackbar-t1');
            this.snackbar = true;
            this.cerrarDialogProveedor();
            this.listarProveedores();
          })
          .catch((error) => {
            const status = error.response?.status;
            const mensaje = error.response?.data?.mensaje;

            if (status === 400 && mensaje) {
              this.snackbar_text = this.$t('suppliers-snackbar-t5');
            } else {
              this.snackbar_text = this.$t('suppliers-snackbar-t2');
            }

            this.snackbar = true;
          });
      }
    },
    editarProveedor(item) {
      this.id_proveedor = item.id_proveedor;
      this.id_empresa = item.id_empresa;
      this.codigo = item.codigo;
      this.nombre = item.nombre;
      this.id_departamento = item.id_departamento;
      this.id_municipio = item.id_municipio;
      this.id_actividad_economica = item.id_actividad_economica;
      this.direccion = item.direccion;
      this.tamaño = item.tamaño;
      this.correo_1 = item.correo_1;
      this.correo_2 = item.correo_2;
      this.telefono = item.telefono;
      this.id_identificador = item.id_identificador;
      this.documento_identificador = item.documento_identificador;
      this.registro = item.registro;
      this.con_retencion = item.con_retencion;
      this.con_percepcion = item.con_percepcion;
      this.activo = item.activo;
      this.exento = item.exento;
      this.exterior = item.exterior;
      this.area = item.area;
      this.id_pais = item.id_pais;
      this.selec_manual = item.selec_manual;
      this.tipo_operacion = item.tipo_operacion;
      this.clasificacion = item.clasificacion;
      this.costo_gastos = item.costo_gastos;

      this.listarMunicipios(item.id_departamento);
      this.listarActividadEconomica(item.id_actividad_economica);
      this.listarPaises("edit");

      this.flag_nuevo_edit = 2;
      this.dialog = true;
    },
    actualizarProveedor() {
      if (this.validarFormulario()) {
        axios
          .put("api/Proveedores/Actualizar", {
            id_proveedor: this.id_proveedor,
            id_departamento: this.id_departamento,
            id_municipio: this.id_municipio,
            id_identificador: this.id_identificador,
            id_pais: this.id_pais,
            id_empresa: this.$store.state.emp.id_empresa,
            id_actividad_economica: this.id_actividad_economica,
            codigo: this.codigo,
            nombre: this.nombre,
            direccion: this.direccion,
            tamaño: this.tamaño,
            correo_1: this.correo_1,
            correo_2: this.correo_2,
            telefono: this.telefono,
            documento_identificador: this.documento_identificador,
            registro: this.registro,
            con_retencion: this.con_retencion,
            activo: this.activo,
            exento: this.exento,
            con_percecion: this.con_percepcion,
            exterior: this.exterior,
            area: this.area,

            //Nuevos
            selec_manual: this.selec_manual,
            tipo_operacion: this.tipo_operacion,
            clasificacion: this.clasificacion,
            costo_gastos: this.costo_gastos,
          })
          .then(() => {
            this.snackbar_text = this.$t('suppliers-snackbar-t3');
            this.snackbar = true;
            this.cerrarDialogProveedor();
            this.listarProveedores();
          })
          .catch(() => {
            this.snackbar_text = this.$t('suppliers-snackbar-t4');
            this.snackbar = true;
          });
      }
    },
    cerrarDialogProveedor() {
      this.dialog = false;
      this.limpiarProveedor();
    },
    limpiarProveedor() {
      this.codigo = "";
      this.nombre = "";
      this.id_departamento = "";
      this.id_municipio = "";
      this.direccion = "";
      this.tamaño = "";
      this.correo_1 = "";
      this.correo_2 = "";
      this.telefono = "";
      this.id_identificador = "";
      this.documento_identificador = "";
      this.registro = "";
      this.con_retencion = false;
      this.activo = true;
      this.exento = false;
      this.con_percepcion = "";
      this.exterior = false;
      this.area = "";
      this.id_pais = "";
      this.id_empresa = 0;

      this.costo_gastos = "";
      this.clasificacion = "";
      this.tipo_operacion = "";

    },
    async listarDepartamentos() {
      this.items_departamento = await (
        await settings.metodos.Departamentos()
      ).data;
    },
    async listarMunicipios(item) {
      var departamento = await (await settings.metodos.Departamento(item)).data;

      this.items_municipio = await (
        await settings.metodos.Municipios(departamento.cod_depa)
      ).data;
    },
    async listarPaises(status) {
      this.items_paises = await (await settings.metodos.Paises()).data;

      if (status == "nuevo") {
        this.dialog_paises = true;
      }
    },
    setPais(event, { item }) {
      this.id_pais = item.id_pais;
      this.dialog_paises = false;
    },
    async listarIdentificadores() {
      this.items_identificador = await (
        await settings.metodos.Identificador()
      ).data;
    },
    async listarTipoDocFiscales() {
      this.items_tipo_doc_fiscal = await (
        await settings.metodos.TipoDocFiscal()
      ).data;
    },
    async listarTipoExportacion() {
      this.items_tipo_export = await (
        await settings.metodos.TipoExportacion()
      ).data;
    },
    async listarActividadEconomica() {
      this.items_actividad_economica = await (
        await settings.metodos.Actividad_Economica()
      ).data;
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-dd");
    },
    estadoRetencion() {
      this.con_percepcion = false;
    },
    estadoPercepcion() {
      this.con_retencion = false;
    },

    validarFormulario() {
      let isValid = true;

      this.errorCodigo = !this.codigo;
      this.errorNombre = !this.nombre;
      this.errorDepartamento = this.id_departamento === null;
      this.errorMunicipio = this.id_municipio === null;
      this.errorActividadEconomica = this.id_actividad_economica === null;
      this.errorTamaño = !this.tamaño;
      this.errorTelefono = !this.telefono;
      this.errorIdentificador = this.id_identificador === null;
      this.errorDocumentoIdentificador = !this.documento_identificador;
      this.errorArea = !this.area;
      this.errorPais = !this.id_pais;

      if (
        this.errorCodigo ||
        this.errorNombre ||
        this.errorDepartamento ||
        this.errorMunicipio ||
        this.errorActividadEconomica ||
        this.errorTamaño ||
        this.errorTelefono ||
        this.errorIdentificador ||
        this.errorDocumentoIdentificador ||
        this.errorArea ||
        this.errorPais
      ) {
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>

<style>
.borde {
  border: 1px solid black;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>